import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid2, IconButton, Tooltip } from "@mui/material"
import MaterialButton from "../../../components/MaterialButton"
import { Close, FileOpen, InsertDriveFile } from "@mui/icons-material"
import MaterialBox from "../../../components/MaterialBox"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialInput from "../../../components/MaterialInput"
import { useEffect, useRef, useState } from "react"
import Swal from "sweetalert2"
import { useLoading } from "../../../context/loading"
import { getPolicyById, postUserPolicy, putUserPolicy } from "./Queries"
import axios from "axios"
import BASEURL, { pdfurl } from "../../Utils/Baseurl"

const PolicyFileUploadDialog = ({open, setOpen, subTabValue, fetchUserListPolicy, fetchHrListPolicy, pageType, selectedPolicyId}) => {
    
    const fileInputRef = useRef(null);
    const { setCirleLoading } = useLoading();
    const [policyData, setPolicyData] = useState({
        title: "",
        titleStatus: "unchecked",
        description: "",
        descriptionStatus: "unchecked",
        document: null,
        documentStatus: "unchecked"
    });

    const documentPath = typeof policyData.document === "string"
        ? policyData.document
            .replace(pdfurl, "")
            .split("?")[0]
            .split("/")
            .pop()
        : null;

    useEffect(() => {
        if(!selectedPolicyId) return;

        if((pageType === "edit" || pageType === "view") && selectedPolicyId){
            fetchPolicyDataById(selectedPolicyId);
        }
    },[selectedPolicyId, pageType]);

    const fetchPolicyDataById = async(policyId) => {
        try{
            const response = await axios.post(BASEURL,
                {
                    query: getPolicyById,
                    variables: { policyId: policyId },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const responseData = response?.data?.data?.policyById;
            if(responseData){
                setPolicyData({
                    title: responseData?.title || "",
                    titleStatus: responseData?.title ? "success" : "unchecked", 
                    description: responseData?.description || "",
                    descriptionStatus: responseData?.description ? "success" : "unchecked",
                    document: responseData?.document ? pdfurl + responseData?.document : null,
                    documentStatus: responseData?.document ? "success" : "unchecked"
                });                
            }            
        }catch(error){
            console.error("Error Fetching Data by ID:",error);
            setOpen(false);
        }
    };
    
    const handleUploadPolicy = async () => {
        //edit
        if (pageType === "edit") {
        setCirleLoading(true);

        try {
            const isNewFile = policyData.document instanceof File;

            const formData = new FormData();

            // Build variables dynamically
            const inputPayload = {
            policyId: selectedPolicyId,
            title: policyData?.title,
            description: policyData?.description,
            };

            // only attach document field if new file uploaded
            if (isNewFile) {
            inputPayload.document = null;
            }

            const operations = JSON.stringify({
            query: putUserPolicy,
            variables: {
                input: inputPayload
            }
            });

            formData.append("operations", operations);

            // Only append map + file if new file exists
            if (isNewFile) {
            formData.append(
                "map",
                JSON.stringify({
                0: ["variables.input.document"]
                })
            );

            formData.append("0", policyData.document);
            }

            const response = await axios.post(BASEURL, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            });

            const responseMessage = response?.data?.data?.updatePolicy?.message;
            const responseSuccess = response?.data?.data?.updatePolicy?.success;

            Swal.fire({
                position: "center",
                icon: responseSuccess ? "success" : "error",
                title: responseMessage,
                showConfirmButton: false,
                timer: 2500,
            });

            if (responseSuccess) {
                if (subTabValue === "userList") {
                    fetchUserListPolicy();
                } else if (subTabValue === "hrList") {
                    fetchHrListPolicy();
                }
                setOpen(false);
            }

        } catch (error) {
            console.error("Error Updating Policy:", error);
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Failed to update policy. Please try again.",
                showConfirmButton: false,
                timer: 1500,
            });

        } finally {
            setCirleLoading(false);
        }
        }
        //create
        else{
            setCirleLoading(true);
            try{
                const formData = new FormData();
                const operations = JSON.stringify({
                    query: postUserPolicy,
                    variables: {
                        input: {
                        title: policyData?.title,
                        description: policyData?.description,
                        document: null
                        }
                    }
                });
                formData.append("operations", operations);
                formData.append(
                    "map",
                    JSON.stringify({
                        0: ["variables.input.document"]
                    })
                );
                formData.append("0", policyData.document);
                const response = await axios.post(BASEURL, formData, {
                    headers: {
                    "Content-Type": "multipart/form-data",
                    },
                });
                const responseMessage = response?.data?.data?.createPolicy?.message;
                const responseSuccess = response?.data?.data?.createPolicy?.success;
                Swal.fire({
                    position: "center",
                    icon: responseSuccess ? "success" : "error",
                    title: responseMessage,
                    showConfirmButton: false,
                    timer: 2500,
                });
                if(responseSuccess){
                    if(subTabValue === "userList"){
                        //fetch user list policy function
                    fetchUserListPolicy();
    
                    }else if(subTabValue === "hrList"){
                        //fetch hr list policy function
                        fetchHrListPolicy();
                    }
                    setOpen(false);
                }
                
            }catch(error){
                console.error("Error Uploading Policy:",error);
                 Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Failed to upload policy. Please try again.",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }finally{
                setCirleLoading(false);            
            }
        }
    };

    const handleChange = (event) => {
        let policyState = {...policyData};
        if(event && event.target){
            switch(event.target.name){
                case "title": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,30})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    policyState[event.target.name + "Status"] = "success";
                    } else {
                    policyState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                case "description": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,150})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    policyState[event.target.name + "Status"] = "success";
                    } else {
                    policyState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                default: {

                    policyState[event.target.name] = event.target.value;
                    policyState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            policyState[event.target.name] = event.target.value;
        }
        setPolicyData(policyState);
    };

    const handleFileSelect = (file) => {
        if (!file) return;

        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png"
        ];

        const maxSize = 10 * 1024 * 1024; // 10MB

        let status = "success";

        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "Only PDF, JPG, PNG files are allowed",
                showConfirmButton: false,
                timer: 1500,
            });
            status = "error";
        }

        if (file.size > maxSize) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: "File must be less than 10MB",
                showConfirmButton: false,
                timer: 1500,
            });
            file = null;
            status = "error";
        }

        setPolicyData(prev => ({
            ...prev,
            document: file,
            documentStatus: status
        }));
    };

    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        handleFileSelect(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const file = e.dataTransfer.files && e.dataTransfer.files[0];
        handleFileSelect(file);
    };

    const handleClearFile = () => {
        setPolicyData(prev => ({
            ...prev,
            document: null,
            documentStatus: "unchecked"
        }))
    };

     const checkAllFields = () => {
        let allowSubmit = false;
        if (
        policyData.titleStatus === "success" &&
        policyData.documentStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }
        return allowSubmit;
    };

    const handleCloseDialog = () => {
        setOpen(false);
        setPolicyData(prev => ({
            ...prev,
            title: "",
            description: "",
            document: null,
            titleStatus: "unchecked",
            descriptionStatus: "unchecked",
            documentStatus: "unchecked"
        }));
    }
    
  return (
    <Dialog open={open} >
        <DialogTitle>
            Upload Policy 
            <Tooltip title="Close" disableInteractive placement="right">
            <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[600],
                }}
                >
                <Close />
            </IconButton>
            </Tooltip>
        </DialogTitle>
        <DialogContent>
            {/* Fields */}
            <MaterialBox>
                <Grid2 container spacing={1}>
                    <Grid2 size={{xs: 12}}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                        Policy Title <span style={{color:"red"}}>*</span>
                        </MaterialTypography>
                        <MaterialInput
                        name="title"
                        value={policyData?.title}
                        onChange={handleChange}
                        error={policyData.titleStatus === "error"}
                        success={policyData.titleStatus === "success"}
                        disabled={pageType === "view"}
                        />
                        {policyData.titleStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Policy Title should be 1-25 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                        {policyData.titleStatus !== "error" && (
                            <FormControl>
                                <FormHelperText>
                                    Policy Title should be 1-25 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{xs: 12}}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                        Description
                        </MaterialTypography>
                        <MaterialInput
                        name="description"
                        value={policyData?.description}
                        onChange={handleChange}
                        error={policyData.descriptionStatus === "error"}
                        success={policyData.descriptionStatus === "success"}
                        disabled={pageType === "view"}
                        multiline
                        rows={3}
                        />
                        {policyData.descriptionStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Description should be 1-150 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                        {policyData.descriptionStatus !== "error" && (
                            <FormControl>
                                <FormHelperText>
                                    Description should be 1-150 characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                     {/* File Upload */}
                    <Grid2 size={{xs: 12}}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                        Policy File <span style={{color:"red"}}>*</span>
                        </MaterialTypography>
                        {/* -------- VIEW Page -------- */}
                        {pageType === "view" && (
                        policyData?.document ? (
                            <>
                            <br/>
                            <Tooltip title="View Policy" placement="right" disableInteractive>
                            <IconButton
                                href={policyData?.document}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                border: "1px solid #d0d7e2",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                p: 1,
                                "&:hover": { backgroundColor: "#eef3ff" }
                                }}
                            >
                                <FileOpen fontSize="large" />
                            </IconButton>
                            </Tooltip>
                            </>
                        ) : (
                            <MaterialBox
                            sx={{
                                border: "2px dashed #d7dbe2",
                                borderRadius: "12px",
                                p: 1,
                                textAlign: "center",
                                backgroundColor: "#fafbfc",
                            }}
                            >
                            <MaterialTypography variant="body2" sx={{ color: "red" }}>
                                No policy document uploaded
                            </MaterialTypography>
                            </MaterialBox>
                        )
                        )}

                        {/* -------- Edit / Add Page -------- */}
                        {pageType !== "view" && (
                        policyData?.document && !(policyData.document instanceof File) ? (
                            // existing file preview
                            <MaterialBox
                        
                            sx={{
                                border: "1px solid #e0e6ed",
                                borderRadius: "10px",
                                padding: "6px",
                                display: "flex",
                                justifyContent: "space-between",
                                backgroundColor: "#fff",
                            }}
                            >
                            <MaterialBox display="flex" alignItems="center" gap={1}>
                                <InsertDriveFile sx={{ color: "#e53935" }} />
                                <MaterialTypography variant="body2">
                                {documentPath}
                                </MaterialTypography>
                            </MaterialBox>

                            <IconButton size="small" onClick={handleClearFile}>
                                <Close fontSize="small" />
                            </IconButton>
                            </MaterialBox>
                        ) : (
                            // Upload
                            <>
                            <MaterialBox
                            onClick={handleBrowseClick}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            sx={{
                                border: "2px dashed #bfc7d1",
                                borderRadius: "14px",
                                backgroundColor: "#f9fbfd",
                                padding: "10px 20px",
                                textAlign: "center",
                                cursor: "pointer",
                                "&:hover": {
                                borderColor: "#2c5da8",
                                backgroundColor: "#f2f6ff",
                                },
                            }}
                            >
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={handleFileChange}
                            />                            

                            <MaterialTypography variant="body2" color="text.secondary" mb={1}>
                                Drag & drop your file here or click to browse
                            </MaterialTypography>

                            <MaterialTypography variant="caption" color="text.secondary">
                                Supported formats: PDF, JPG, PNG (Max 10MB)
                            </MaterialTypography>
                            </MaterialBox>
                            {policyData?.document?.name && (
                                <MaterialBox
                                mt={1}
                                sx={{
                                    border: "1px solid #e0e6ed",
                                    borderRadius: "10px",
                                    padding: "6px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    backgroundColor: "#fff",
                                }}
                                >
                                    <MaterialBox display="flex" alignItems="center" gap={1}>
                                        <InsertDriveFile sx={{ color: "#e53935" }} />
                                        <MaterialTypography variant="body2">
                                        {policyData?.document?.name}
                                        </MaterialTypography>
                                    </MaterialBox>
                                </MaterialBox>
                            )}
                            </>
                        )
                        )}                    

                        
                    </Grid2>                    
                </Grid2>
            </MaterialBox>           
        </DialogContent>
        <DialogActions>
            {pageType !== "view" && (
            <MaterialButton
            variant="gradient"
            color="dark"
            size="small"
            disabled={!checkAllFields()}
            onClick={handleUploadPolicy}>
                {pageType === "edit" ? "Update" : "Upload"}
            </MaterialButton>
            )}
        </DialogActions>
    </Dialog>
  )
}

export default PolicyFileUploadDialog